import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetAccountGroupsService } from "@/features/accounts/account-group/services/get-account-groups-service";
import { UpdateAccountGroupsService } from "@/features/accounts/account-group/services/update-account-groups-service";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
import { useContext, useRef } from "react";


export const useGetAccountGroups = () => {
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  const {
    userSelectedAccountGroupId,
    setAccountGroups,
    setSelectedAccountGroup,
    setAccounts,
  } = useAccountGroupsContext();

  // 口座一覧取得管理ID
  const latestGetAccountGroupRequestId = useRef(0);

  const getAccountGroupsService = new GetAccountGroupsService();
  const updateAccountGroupsService = new UpdateAccountGroupsService();

  /*--------------------
    イベント関連
  --------------------*/
  // 口座グループ一覧取得
  const getAccountGroups = async (
    includeAccounts: boolean,
  ) => {
    const requestId = ++latestGetAccountGroupRequestId.current;
    try {
      const accountGroups = await getAccountGroupsService.getAccountGroups({
        include_accounts: includeAccounts,
      });
      // 口座グループをコンテキストに保存
      const groups = accountGroups.map((item) => ({
        accountGroupId: item.account_group_id,
        accountGroupsName: item.account_group_name,
        sortOrder: item.sort_order,
        isSelected: (item.shared === 1 && item.is_owner === 0) ? false : item.is_selected,
        shared: item.shared,
        isOwner: item.is_owner,
        accountsList: (item.accounts_list.map((account) => ({
          mlinkId: account.mlink_id,
          mlinkAccountId: account.mlink_account_id,
          passbookType: account.passbook_type,
          passbookName: account.passbook_name,
          lastAggregate: account.last_aggregate
        }))),
        getFinance: item.get_finance,
        getCreca: item.get_creca,
        getPaymentCreca: item.get_payment_creca,
        getPaymentElectronicmoney: item.get_payment_electronicmoney,
        getEcshop: item.get_ecshop,
        getCsvexcel: item.get_csvexcel,
        getOcr: item.get_ocr,
        getScrapFinance: item.get_scrap_finance,
      }));
      if (requestId === latestGetAccountGroupRequestId.current) {
        setAccounts([]); // この後口座一覧取得をし直すため口座一覧をリセット
        setAccountGroups(groups);
        // groupsの中でaccountGroupIdがuserSelectedAccountGroupIdと一致するものをselectedAccountGroupに設定
        // 該当がなければgroupsの中でisSelectedがtrueのものをselectedAccountGroupに設定
        // それでも該当がなければ1つ目の要素を設定する
        let selectedGroup = groups.find((item) => item.accountGroupId === userSelectedAccountGroupId);
        if (!selectedGroup) {
          selectedGroup = groups.find((item) => item.isSelected);
          if (!selectedGroup) {
            await updateAccountGroupsService.updateAccountGroups({
              account_group_id: groups[0].accountGroupId,
              is_selected: true,
            });
            selectedGroup = groups[0];
          }
        }
        setSelectedAccountGroup(selectedGroup);
      }
    } catch (error) {
      // エラーハンドリング
      console.log("getAccountGroups:", error);
    } finally {
      //
    }
  };

  return {
    getAccountGroups: errorHandledAsync(getAccountGroups, setError),
  };
};
